module.exports = __webpack_public_path__ + "static/media/icon_fechar_x.3fed361c.svg";